import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEditFileFolder } from "../../../../store/spreadsheet/thunks";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
import Modal from "../../../../components/generic/Modal";
import { Alert } from "antd";

const RemoveModal = ({ onCancel, record, folder_id }) => {
  const [submitting, setSubmitting] = useState(false);
  const { isFile } = record;

  const selectedTenantId = useSelector(selectSelectedTenantId);

  const dispatch = useDispatch();

  const onOk = useCallback(async () => {
    try {
      setSubmitting(true);
      await dispatch(
        addEditFileFolder({
          tenant_id: selectedTenantId,
          type: "delete",
          folder_id: record?.isFile ? folder_id : record?.id,
          workbook_id: record?.isFile ? record?.id : undefined,
        }),
      );
      onCancel();
    } catch (error) {
      console.log("🚀 ~ RemoveModal.jsx:6 ~ RemoveModal ~ error:", error);
    } finally {
      setSubmitting(false);
    }
  }, [selectedTenantId, record]);

  return (
    <Modal
      open
      title={`Remove ${isFile ? "Workbook" : "Folder"}`}
      okText={`Yes, Remove`}
      okType="danger"
      onOk={onOk}
      onCancel={onCancel}
      isProcessing={submitting}
    >
      Are you sure you want to remove <strong>{record?.name}</strong> ?
      {!record?.isFile && (
        <Alert
          style={{ marginTop: 16 }}
          type="warning"
          showIcon
          message="All workbooks inside this folder will also be deleted."
        />
      )}
    </Modal>
  );
};

export default RemoveModal;
